import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-charts-12v1',
  templateUrl: './12v1.component.html',
})
export class VbChart12v1Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
